import { useFormikContext } from 'formik';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import Radio from '../../../../../../../components/Radio/Radio';
import { useAppSelector } from '../../../../../../../reduxService/hooks';
import { selectProject } from '../../../../../selector/conversion';
import { IFormikFormSectors } from '../FormikSubsector';
import { getEmptySubsector } from '../../../../../utils/utils';
import { SubSectorPosition } from '../../../../../enum/Sector';
type Props = {};
export const RadioSectorBtns = (props: Props) => {
    const project = useAppSelector(selectProject);
    const { t } = useTranslation();
    const { values, setFieldValue } = useFormikContext<IFormikFormSectors>();
    let geo = [...project.data!.geometry!];
    geo.sort((a, b) => a.channel - b.channel);
    return (
        <div className='d-flex align-items-center gap-1'>
            {t('modal_subsector_sector_channel')}
            {!!geo &&
                geo.length > 0 &&
                geo.map(sec => (
                    <Radio
                        key={sec.channel}
                        title={sec.channel.toString()}
                        name='sectorNumber'
                        value={sec.channel}
                        checked={values.choosenSector == sec.channel}
                        onChange={e => {
                            const sector = parseInt(e.target.value);
                            setFieldValue('choosenSector', sector);
                            setFieldValue('subSectorNumber', SubSectorPosition.Right);

                            const sectorFromProject = project.data?.geometry?.find(ele => ele.channel === sector);
                            if (!!sectorFromProject && !!sectorFromProject.subSectors && sectorFromProject.subSectors.length > 0) {
                                sectorFromProject.subSectors.forEach(ele => setFieldValue(`${values[sector][ele.position]}`, ele));
                            } else {
                                setFieldValue(`${sector}.0`, getEmptySubsector(0, values[sector]));
                            }
                        }}
                    />
                ))}
        </div>
    );
};
